export const MAX_ATTACHMENT_FILE_BYTES = 15_000_000;

export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".csv",
  ".xlsx",
  ".xls",
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".json",
  ".mp4",
  ".zip",
] as const;

export const ALLOWED_EXTRACTED_ATTACHMENT_EXTENSIONS = ALLOWED_ATTACHMENT_EXTENSIONS.filter(
  (extension) => extension !== ".zip",
);

export const ATTACHMENT_FILE_INPUT_ACCEPT = ALLOWED_ATTACHMENT_EXTENSIONS.join(",");

const ALLOWED_ATTACHMENT_TYPE_LABEL =
  "PDF, DOC, DOCX, TXT, CSV, XLSX, XLS, PNG, JPG, JPEG, GIF, JSON, MP4, ZIP";

export const ATTACHMENT_MAX_FILE_SIZE_ERROR = "Any one file cannot be larger than 15MB";
export const ATTACHMENT_UNSUPPORTED_TYPE_ERROR = `Unsupported file type. Allowed types: ${ALLOWED_ATTACHMENT_TYPE_LABEL}.`;

export const isAllowedAttachmentExtension = (filename: string): boolean => {
  const lowerFilename = filename.toLowerCase();
  return ALLOWED_ATTACHMENT_EXTENSIONS.some((ext) => lowerFilename.endsWith(ext));
};

export const isAllowedExtractedAttachmentExtension = (filename: string): boolean => {
  const lowerFilename = filename.toLowerCase();
  return ALLOWED_EXTRACTED_ATTACHMENT_EXTENSIONS.some((ext) => lowerFilename.endsWith(ext));
};
